import moment from 'moment';
import appState from './../constants';
import { fetchTeamTransactions, fetchMoreTeamTransactions } from './../api/api';
import formatUserFeedback, { formatTransactionsShields, checkIfIsNew } from './commonTransactions';

/**
 * @param {String} situationName Situation name
 * @returns {String}
 */
function getSituacaoIcon(situationName) {
  switch (true) {
    case (situationName.toLowerCase() === 'chegando'): {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 186.1 177.9">
          <path fill="#fff" d="M162.2 16.5h-33.3l33.7 10c.7.2 1.2.9 1.2 1.6V150h9.9V28.1c.1-6.4-5.1-11.6-11.5-11.6z"/>
          <path fill="#fff" d="M161.1 28L116 14.6c-.5-.1-.8.3-.8.9v147.1c0 .6.4 1 .8.9l45.1-13.4c.3-.1.6-.6.6-1.1V29c-.1-.4-.3-.9-.6-1zm-31.5 68.7c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zM99.7 62.3c-1.2-1.6-2.8-2.4-4.6-2.4-1.4 0-2.9.5-4.4 1.5-1.5 1-2.9 2.2-4.4 3.2-1.4 1-2.7 2-4.4 3.1-2.9-2.6-5.6-5.3-8.6-7.5-1.6-1.2-3.8-1.8-5.9-2.3-.7-.1-1.4-.2-2.1-.2-1.1 0-2.3.1-3.4.1-18.3 0-18.3.1-34.3 8.9-3.3 1.8-4.7 4.2-4.2 8 .7 4.6 1.1 9.3 1.9 14 .6 3.8 3 6.1 6.1 6.1.3 0 .7 0 1.1-.1 3.5-.6 5.6-3.9 5-8-.2-1.3-.4-2.6-.5-3.9-.8-7.4-.8-7.4 6.9-9.9.1 1.2.3 2.3.3 3.4 0 5.5-.5 11 .1 16.4 1.1 10.4-1.8 19.6-7.2 28.1-.8 1.3-2.3 2.5-3.7 3.1-4.2 1.8-8.6 3.2-12.8 4.8-4.7 1.9-6.8 5.7-5.3 9.8 1.1 3.2 3.7 5.1 7 5.1 1.1 0 2.3-.2 3.6-.6 5.8-2 11.7-3.9 17.2-6.4 2.4-1.1 4.6-3.4 6.1-5.7 3.4-5.2 6.3-10.8 9.6-16.6 5.9 4.4 11.8 8.5 17.2 13.1 1.6 1.3 2 4.1 2.8 6.3 1.3 3.5 2.4 7.2 3.8 10.7 1.4 3.5 4.1 5.5 7.3 5.5.9 0 1.8-.2 2.7-.5 3.9-1.4 5.8-5.5 4.3-10-1.9-5.8-3.7-11.7-6.1-17.3-1.2-2.7-3.5-5.2-5.8-7.2-3.6-3.2-7.8-5.7-11.5-8.8-1.1-.9-1.7-2.6-2.4-4.1-.2-.5 0-1.3 0-1.9V74.5c2.6 2.3 4.6 3.9 6.5 5.6 1.3 1.1 2.6 1.7 3.9 1.7 1.1 0 2.3-.4 3.5-1.3 4.3-3.2 8.7-6.3 12.9-9.5 3.3-2.3 3.9-5.8 1.8-8.7z"/>
          <path fill="#fff" d="M86.2 82.3c-.2.1-.3.2-.5.3V113c.2.2.4.3.6.5 3 2.6 5.2 5.3 6.3 7.9 1.1 2.6 2.1 5.2 3 7.8V75.5c-1.3.9-2.5 1.9-3.8 2.8-1.8 1.3-3.7 2.7-5.6 4zM97.3 16.5c-6.4 0-11.6 5.2-11.6 11.6v34.3c.3-.2.5-.4.8-.6 1-.7 1.9-1.5 3-2.1 1.8-1.2 3.7-1.8 5.6-1.8h.6V28.1c0-.9.8-1.7 1.7-1.7H113v-9.9H97.3zM57.7 28.4c-7.4 0-13.5 6.1-13.5 13.4 0 7.3 6.1 13.5 13.4 13.5h.1c7.4 0 13.5-6.2 13.5-13.5 0-7.4-6-13.4-13.5-13.4z"/>
        </svg>
      `;
    }
    default: {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 186.1 164.6">
          <path fill="#fff" d="M23.7 9.2H57l-33.7 10c-.8.2-1.3.8-1.3 1.6v121.9h-9.9V20.8c0-6.4 5.2-11.6 11.6-11.6z"/>
          <path fill="#fff" d="M24.2 21.8v120c0 .5.3 1 .6 1.1l45.1 13.4c.5.1.8-.3.8-.9V8.2c0-.6-.4-1-.8-.9L24.8 20.7c-.4 0-.6.5-.6 1.1zm26.1 61.6c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6c-3.4-.1-6-2.7-6-6zM90.2 20.8V127c.8-.6 1.7-1.1 2.8-1.5 1.8-.7 3.7-1.4 5.5-2 .5-.2 1.1-.4 1.6-.6V94.1c-1.9-1.3-3.2-3.6-3.6-6.4-.4-2.5-.7-5-1-7.5-.3-2.1-.5-4.3-.9-6.5-.7-4.5 1-7.8 5.2-10.1l.3-.2V20.8c0-6.4-5.2-11.6-11.6-11.6H72.9v9.9h15.6c.9 0 1.7.8 1.7 1.7z"/>
          <path fill="#fff" d="M172.8 60.9c-1.2-1.6-2.8-2.4-4.6-2.4-1.4 0-2.9.5-4.4 1.5-1.5 1-2.9 2.2-4.4 3.2-1.4 1-2.7 2-4.4 3.1-2.9-2.6-5.6-5.3-8.6-7.5-1.6-1.2-3.8-1.8-5.9-2.3-.7-.1-1.4-.2-2.1-.2-1.1 0-2.3.1-3.4.1-18.3 0-18.3.1-34.3 8.9-3.3 1.8-4.7 4.2-4.2 8 .7 4.6 1.1 9.3 1.9 14 .6 3.8 3 6.1 6.1 6.1.3 0 .7 0 1.1-.1 3.5-.6 5.6-3.9 5-8-.2-1.3-.4-2.6-.5-3.9-.8-7.4-.8-7.4 6.9-9.9.1 1.2.3 2.3.3 3.4 0 5.5-.5 11 .1 16.4 1.1 10.4-1.8 19.6-7.2 28.1-.8 1.3-2.3 2.5-3.7 3.1-4.2 1.8-8.6 3.2-12.8 4.8-4.7 1.9-6.8 5.7-5.3 9.8 1.1 3.2 3.7 5.1 7 5.1 1.1 0 2.3-.2 3.6-.6 5.8-2 11.7-3.9 17.2-6.4 2.4-1.1 4.6-3.4 6.1-5.7 3.4-5.2 6.3-10.8 9.6-16.6 5.9 4.4 11.8 8.5 17.2 13.1 1.6 1.3 2 4.1 2.8 6.3 1.3 3.5 2.4 7.2 3.8 10.7 1.4 3.5 4.1 5.5 7.3 5.5.9 0 1.8-.2 2.7-.5 3.9-1.4 5.8-5.5 4.3-10-1.9-5.8-3.7-11.7-6.1-17.3-1.2-2.7-3.5-5.2-5.8-7.2-3.6-3.2-7.8-5.7-11.5-8.8-1.1-.9-1.7-2.6-2.4-4.1-.2-.5 0-1.3 0-1.9V73.1c2.6 2.3 4.6 3.9 6.5 5.6 1.3 1.1 2.6 1.7 3.9 1.7 1.1 0 2.3-.4 3.5-1.3 4.3-3.2 8.7-6.3 12.9-9.5 3.3-2.3 3.9-5.8 1.8-8.7zM130.9 27s-.1 0 0 0c-7.4 0-13.5 6.1-13.5 13.4 0 7.3 6.1 13.5 13.4 13.5h.1c7.4 0 13.5-6.2 13.5-13.5-.1-7.3-6.1-13.3-13.5-13.4z"/>
        </svg>
      `;
    }
  }
}

/**
 * @param {String} situationName Situation name
 * @returns {String}
 */
function createSituationHeader(situationName) {
  return `
    <div class="situacao-header-container">
      <div class="situacao-icon">
        <div class="icon-container">${getSituacaoIcon(situationName)}</div>
      </div>
      <div class="situacao-title">${situationName}</div>
    </div>
  `;
}

/**
 * @param {Boolean} isChegando If is Changando
 * @param {Object} singleTransaction Single transaction
 * @param {Object} transaction Single transaction
 * @returns {String}
 */
function getOriginTeams(isChegando, singleTransaction, transaction) {
  const { saindo } = transaction;
  const { selectedTeam } = appState;

  if (isChegando) {
    return formatTransactionsShields(saindo); // eslint-disable-line
  }

  return `
    <div class="single-team-container">
      <div class="transaction-team team-1" data-team-name="${selectedTeam.name}">
        <img class="escudo" src=${selectedTeam.shield} alt="${selectedTeam.name}" />
        <div class="team-initials">${selectedTeam.initials}</div>
      </div>
    </div>
  `;
}

/**
 * @param {Boolean} isChegando If is Changando
 * @param {Object} singleTransaction Single transaction
 * @param {Object} transaction Single transaction
 * @returns {String}
 */
function getDestinationTeams(isChegando, singleTransaction, transaction) {
  const { chegando } = transaction;
  const { selectedTeam } = appState;

  if (isChegando) {
    return `
      <div class="single-team-container">
        <div class="transaction-arrow">
          <svg viewBox="0 0 136 143" xmlns="http://www.w3.org/2000/svg">
            <path d="M75.504 89.42h-62.1c-8.1 0-12.5-4.2-12.5-12.2v-11.2c.2-7.3 4.6-11.7 12-11.7h63c-1-1.2-1.7-1.7-2.4-2.7l-23.4-23.4c-6.1-6.1-6.1-12.5 0-18.3l5.9-5.9c5.1-4.9 11.5-4.9 16.6-.2.7.7 1.7 1.7 2.7 2.4l55.2 55.2c7.1 7.1 7.1 13.2 0 20l-56.2 56.2c-6.6 6.6-12.7 6.6-19.5 0l-5.1-5.1c-4.9-5.1-4.9-11.7 0-16.9l23.7-23.7c.7-.7 1.7-1.2 2.7-2-.3.2-.3-.1-.6-.5z" fill="currentColor"/>
          </svg>
        </div>
        <div class="transaction-team team-2" data-team-name="${selectedTeam.name}">
          <img class="escudo" src=${selectedTeam.shield} alt="${selectedTeam.name}" />
          <div class="team-initials">${selectedTeam.initials}</div>
        </div>
      </div>
    `;
  }
  return formatTransactionsShields(chegando, true); // eslint-disable-line
}

/**
 * @param {Object} transactions Single transaction
 * @returns {String}
 */
function formatTransactionStatuses(transactions) {
  if (Array.isArray(transactions)) {
    return transactions.map((transaction) => { // eslint-disable-line
      return `
        <div class="single-transaction-status">
          <div class="transaction-icon-container">
            <img src="${transaction.status_projeto.icone.url}" class="transaction-icon" />
          </div>
          <div class="transaction-name">${transaction.status_projeto.nome}</div>
        </div>
      `;
    }).join('');
  }

  return `
    <div class="single-transaction-status">
      <div class="transaction-icon-container">
        <img src="${transactions.status_projeto.icone.url}" class="transaction-icon" />
      </div>
      <div class="transaction-name">${transactions.status_projeto.nome}</div>
    </div>
  `;
}

/**
 * @param {Object} player transactions
 * @param {Object} transaction Single transaction
 * @param {String} situation Situation "Chegando" ou "Saindo"
 * @returns {String}
 */
function createSingleRowByStatus(player, transaction, situation) {
  const { saindo, chegando } = transaction;

  const isChegando = situation.toLowerCase() === 'chegando';
  const transactionsToCreate = isChegando ? chegando : saindo;

  /* eslint-disable */
  return transactionsToCreate.map((singleTransaction) => { // eslint-disable-line
    return `
      <div class="transaction-row-container">
        <div class="visible-content ${player.text ? '' : 'no-collapsed-content'}">
          <div class="player-details-container">
            <div class="player-image-container">
              <img class="player-image" src="${player.foto}">
            </div>
            <div class="player-details">
              <div class="player-main-details">
                <div class="player-name">${player.nome}
                  <span class="player-position-and-tag">
                    <span class="player-position">${ player.posicao_sigla }</span>
                    ${checkIfIsNew(chegando, saindo)}
                  </span>
                </div>
                <div class="player-update-date">Atualizado ${moment(player.data_ultima_atualizacao).format('DD/MM/YYYY, HH[h]mm')}</div>
              </div>
            </div>
          </div>
          <div class="transaction-shields">
            <div class="origin-teams">
              ${getOriginTeams(isChegando, singleTransaction, transaction)}
            </div>
            <div class="destination-teams">
              ${getDestinationTeams(isChegando, singleTransaction, transaction)}
            </div>
          </div>
          <div class="transaction-status-container">
            ${formatTransactionStatuses(isChegando ? singleTransaction : chegando.length ? chegando : saindo)}
          </div>
          <div class="user-feedbacks">
            ${formatUserFeedback(isChegando ? singleTransaction : chegando.length ? chegando : saindo)} 
          </div>
        </div>
        <div class="collapsed-content">
          <div class="collapsed-content-text">
            ${player.text}
          </div>
          <div class="close-collapsed-content">
            Fechar
            <div class="close-collapsed-content-icon">
              <svg viewBox="0 0 101 101" xmlns="http://www.w3.org/2000/svg">
                <path d="M99.8 19.2C99.6 8.1 91.6.4 80.5.4H19.4c-1.9 0-3.8.2-5.7.8C5.5 3.5.1 10.8.1 20.2v61.1c0 11.1 8 19.3 19.3 19.3h61.9c10.2 0 18.6-8 18.8-18.2-.1-21.2-.1-42.3-.3-63.2zM75.5 71.9l-4.6 4.6c-2.3 2.1-4.6 2.1-6.7 0L51.6 63.9l-1.7-1.7-7.9 7.9-6.5 6.5c-2.1 2.1-4.4 2.1-6.5 0l-5-5c-2.3-2.3-2.3-4.6 0-6.9l13.8-13.8s0-.2.2-.4L36.5 49c-4.2-4.2-8.2-8.2-12.3-12.5-2.5-2.5-2.5-4.8 0-7.5 1.3-1.5 2.9-2.9 4.4-4.4 2.7-2.7 4.8-2.7 7.5.2l13.8 13.8 1.7-1.7 12.6-12.6c2.3-2.3 4.6-2.3 7.1 0 1.7 1.5 3.3 3.3 5 5 2.1 2.3 2.3 4.6 0 6.7L63.7 48.6 62 50.3l13.6 13.6c2.8 3 2.8 5.1-.1 8z" fill="currentColor"/>
              </svg>
            </div>
          </div>
          <a href="${player.url}" target="_blank" class="collapsed-read-more">
            Ler mais
            <div class="collapsed-read-more-icon">
              <svg viewBox="0 0 159 119" xmlns="http://www.w3.org/2000/svg">
                <path d="M89 79.9H10.3c-8.5 0-9.4-.9-9.4-9.5V48.9c0-8.1.9-9 8.8-9h79.2v-5.5c0-9.3-.2-18.7.1-28 .1-2 1.3-4.8 2.9-5.6C93.4 0 96.6.7 98 2c19.6 17.6 39 35.4 58.4 53.1 3.3 3 3 5.9-.2 8.9-19.3 17.7-38.4 35.5-57.8 53-1.5 1.4-4.8 2.5-6.4 1.7-1.6-.7-2.9-3.9-2.9-6-.2-10.5-.1-21.4-.1-32.8z" fill="currentColor"/>
              </svg>
            </div>
          </a>
        </div>
      </div>
    `;
    /* eslint-enable */
  }).join('');
}

/**
 * @param {Object} playerAndTransactions Player and transactions
 * @param {String} situation Situation
 * @returns {String}
 */
function createTeamTransactionRows(playerAndTransactions, situation) {
  if (playerAndTransactions.atletas.length) {
    return playerAndTransactions.atletas.map(singleAtleta => createSingleRowByStatus(singleAtleta.atleta, singleAtleta.transacoes, situation)).join('');
  }
  return '<p class="empty-result">Não existem transações nessa seção</p>';
}

/**
 * @param {Object} transactions Transactions
 * @param {String} situation Situation
 * @returns {string}
 */
function getViewMoreButton(transactions, situation) {
  const { ver_mais: hasSeeMore } = transactions;

  if (hasSeeMore) {
    return `
      <div class="view-more-team-transactions" data-team-id="${appState.selectedTeam.id}" data-page="1" data-situation="${situation}">
        <div class="view-more-icon">
          <svg viewBox="0 0 101 101" xmlns="http://www.w3.org/2000/svg">
            <g fill="currentColor" fill-rule="nonzero">
                <path d="M100.516 50.72v29c0 12.2-8.8 21-21 21h-58.2c-11.6 0-20.7-9.1-20.7-20.7v-58.2c0-12.5 8.8-21 21.3-21h57.4c12.5 0 21.3 8.8 21.3 21-.1 9.6-.1 19.3-.1 28.9zm-49.7-40.9h-28.7c-8 0-12.5 4.5-12.5 12.5v56.8c0 8 4.5 12.5 12.5 12.5h56.5c8 0 12.8-4.5 12.8-12.8v-56.5c0-8-4.5-12.5-12.5-12.5h-28.1z"></path>
                <path d="M46.016 45.92v-23.3c0-3.1.6-3.7 4-3.7h2c2.6 0 3.1.6 3.1 3.1v24.1H79.016c2.8 0 3.4.6 3.4 3.4 0 5.7 0 5.7-5.4 5.7h-21c-.3 0-.3.3-.6.3v23.5c0 2.6-.6 3.1-3.4 3.1-5.7 0-5.7 0-5.7-5.7v-21.6H22.416c-2.8 0-3.4-.6-3.4-3.4 0-5.7 0-5.7 5.4-5.7h21c0 .5.3.5.6.2z"></path>
            </g>
          </svg>
        </div>
        <div class="view-more-label">
          ver mais
        </div>
      </div>
      
      <div class="loading-data">
        <div class="loading-outer-container">
          <div class="loading-container">
            <div class="loading-spinner-container">
              <div class="loading-spinner"></div>
            </div>
            <span class="loading-label">Carregando transações</span>
          </div>
        </div>
      </div>
    `;
  }
  return '';
}

/**
 * @param {Object} $this This reference
 */
export default async function showTeamTransactions($this) {
  const teamID = $this.attr('data-team-id');
  const teamShield = $this.attr('data-escudo');
  const teamInitials = $this.attr('data-initials');
  const teamName = $this.attr('data-name');
  const teamsTransactions = await fetchTeamTransactions(teamID);
  const { saindo, chegando } = teamsTransactions.situacoes;

  appState.selectedTeam = {
    ...appState.selectedTeam,
    id: teamID,
    name: teamName,
    shield: teamShield,
    initials: teamInitials,
  };

  $('.single-tab-content-teams .loading-outer-container').removeClass('is-visible');

  const teamPageContent = `
    <div class="team-header">
      <img class="team-shield" src="${teamShield}" />
      <div class="team-title">${teamName}</div> 
    </div>
    <div class="transactions-chegando-container">
      ${createSituationHeader('Chegando')}
      ${createTeamTransactionRows(chegando, 'chegando')}
    </div>
    ${getViewMoreButton(chegando, 'chegando')}
    <div class="transactions-saindo-container">
      ${createSituationHeader('Saindo')}
      ${createTeamTransactionRows(saindo, 'saindo')}
    </div>
    ${getViewMoreButton(saindo, 'saindo')}
  `;

  $('.single-tab-content-teams .team-transactions-container').html(teamPageContent);
  setTimeout(() => {
    $('.tabs-content')[0].slick.setPosition();
  }, 200);
}

/**
 * @param {Object} event Event object
 */
export async function viewMoreTeamTransactions(event) {
  event.preventDefault();
  const teamID = $(this).attr('data-team-id');
  const teamSituation = $(this).attr('data-situation');
  const nextPage = Number($(this).attr('data-page')) + 1;
  const $containerToAppendTransactions = $(`.transactions-${teamSituation}-container`);
  const $loading = $(this).siblings('.loading-data').find('.loading-outer-container');

  $(this).addClass('is-disabled');
  $loading.addClass('is-visible');

  const { atletas, paginator } = await fetchMoreTeamTransactions(teamID, teamSituation, nextPage);
  const { pagina, paginas } = paginator;
  const isLastPage = Number(pagina) === Number(paginas);

  if (isLastPage) {
    $(this).addClass('is-hidden');
  }
  $loading.removeClass('is-visible');
  $(this).removeClass('is-disabled');
  $(this).attr('data-page', nextPage);

  const newTransactions = atletas.map(atleta => createSingleRowByStatus(atleta.atleta, atleta.transacoes, teamSituation)).join('');
  $containerToAppendTransactions.append(newTransactions);

  $('.tabs-content')[0].slick.setPosition();
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/components/teamTransactions.js